'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

const _react = require('react');

const React = _interopRequireWildcard(_react);

const _propTypes = require('prop-types');

const _propTypes2 = _interopRequireDefault(_propTypes);

const _classnames = require('classnames');

const _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { let newObj = {}; if (obj != null) { for (let key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

export const MultiToggle = function MultiToggle(_ref) {
  let selectedOption = _ref.selectedOption,
    options = _ref.options,
    onSelectOption = _ref.onSelectOption,
    className = _ref.className,
    label = _ref.label,
    componentName = _ref.name,
    disabled = _ref.disabled,
    kleurbalk = _ref.kleurbalk === undefined || _ref.kleurbalk === null ? true : _ref.kleurbalk;


  // If required variables aren't passed, return empty
  if (!options || selectedOption === null) return null;

  const numOptions = options.length;

  const columnWidth = numOptions ? 100 / numOptions : numOptions;

  const isSelectedOption = function isSelectedOption(option) {
    return option.value == selectedOption;
  };

  const getStyleBackground = function isSelectedOption2(option) {
    //if (disabled) return "disabled";
    if (kleurbalk) {
      let ix = getSelectedIndex();
      return options[ix] ? options[ix].optionClass : null;
    }
    else {
      return option ? option.optionClass : null;
    }
  };

  const getStyleRoundedCorner = function getStyleRoundedCorner(args) {
    if (args[1] === 0) {
      return "first";
    }
    else if (args[1] === args[2].length - 1) {
      return "last";
    }
    return null;
  };

  const getStyleRoundedCornerSelected = function getStyleRoundedCornerSelected(length) {
    if (getSelectedIndex() === 0) {
      return "first";
    }
    else if (getSelectedIndex() === length - 1) {
      return "last";
    }
    return null;
  };

  const getSelectedIndex = function getSelectedIndex() {
    const indexFound = options.findIndex(function (option) {
      return isSelectedOption(option);
    });
    return indexFound > -1 ? indexFound : 0;
  };

  const createToggleOption = function createToggleOption() {
    // eslint-disable-next-line no-var
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    const selectOption = function selectOption() {
      if (!disabled) {
        const obj = { target: { name: componentName, value: args[0].value } };

        return onSelectOption(obj);
      }
    };

    const optionClass = (0, _classnames2.default)('toggleOption', { selected: isSelectedOption(args[0]) }, getStyleBackground(args[0]), getStyleRoundedCorner(args));
    const optionStyle = {
      width: columnWidth + '%'
    };
    return React.createElement(
      'div',
      {
        key: args[1],
        onClick: selectOption,
        className: optionClass,
        style: optionStyle
      },
      args[0].displayName || args[0].value
    );
  };

  const toggleClass = (0, _classnames2.default)('toggleContainer', className);

  let toggleStyle = {
    left: (getSelectedIndex() * (100 / options.length)) + "%"
  };

  const renderLabel = label ? React.createElement(
    'label',
    null,
    label
  ) : null;

  return React.createElement(
    'div',
    { className: 'toggle-wrapper' },
    renderLabel,
    React.createElement(
      'div',
      { className: toggleClass },
      options.map(createToggleOption),
      disabled ? null : <span className="btn" style={toggleStyle}><i className={options[getSelectedIndex()].optionClass + " fa"}></i></span>
    )
  );
};

MultiToggle.propTypes = {
  className: _propTypes2.default.string,
  options: _propTypes2.default.array.isRequired,
  selectedOption: _propTypes2.default.string.isRequired,
  onSelectOption: _propTypes2.default.func,
  label: _propTypes2.default.string,
  componentName: _propTypes2.default.string.isRequired
};